const LoadingOverlay = ({ loading, text = 'Loading...' }) => {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-400 bg-opacity-40 block-ui-overlay block-ui-container">
      <div className="block-ui-message-container">
        <div className="block-ui-message">{text}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
